import React, { useState, useEffect } from "react";
import { IoEyeOff, IoEye } from "react-icons/io5";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import { PANEL_TYPES, REMOTE_TYPES, SERVER_TYPES } from "../utills/constant";
// import { fetchServerTypes, fetchDataCenterLocations, fetchRemoteTypes, fetchPanelTypes } from "../utills/constant";
import { getAllRdps, saveNewRdps } from "../store/actions/rdp";
import { IoArrowBack } from "react-icons/io5";
import mongoose from "mongoose";


// import { useDispatch, useSelector } from "react-redux";

import { getAllServerType } from "../store/actions/servertype";
import { getAllDataCenter } from "../store/actions/DataCenter";
import { getAllRemoteControl } from "../store/actions/remoteControl";
import { getAllRemotePanel } from "../store/actions/remotePanel";
import { getAllServer } from "../store/actions/server";

const ServerListAdd = () => {
  
  const [serverTypes, setServerTypes] = useState([]);
  const [dataCenters, setDataCenters] = useState([]);
  const [remoteTypes, setRemoteTypes] = useState([]);
  const [panelTypes, setPanelTypes] = useState([]);
  const [servers, setServers] = useState([]);

  const [filteredRemoteTypes, setFilteredRemoteTypes] = useState([]);
  const [filteredPanelTypes, setFilteredPanelTypes] = useState([]);
  const dispatch = useDispatch();

  

  // Call APIs on mount
  useEffect(() => {
    dispatch(getAllServerType());
    dispatch(getAllDataCenter());
    dispatch(getAllRemoteControl());
    dispatch(getAllRemotePanel());
    dispatch(getAllServer());
  }, [dispatch]);


  // Access data from Redux store
  const serverTypesLst = useSelector((state) => state.serverType);
const dataCentersList = useSelector((state) => state.DataCenter);
const remoteControls = useSelector((state) => state.RemoteControl);
const remotePanels = useSelector((state) => state.RemotePanel);
const serverlist = useSelector((state) => state.server);

 useEffect(() => {
  setServerTypes(Array.isArray(serverTypesLst?.servers) ? serverTypesLst.servers : []);
    }, [serverTypesLst]);

    useEffect(() => {
      setDataCenters(Array.isArray(dataCentersList?.servers) ? dataCentersList.servers : []);
        }, [dataCentersList]);


        useEffect(() => {
          setRemoteTypes(Array.isArray(remoteControls?.servers) ? remoteControls.servers : []);
            }, [remoteControls]); 
            
            useEffect(() => {
              setPanelTypes(Array.isArray(remotePanels?.servers) ? remotePanels.servers : []);
                }, [remotePanels]); 

                useEffect(() => {
                  setServers(Array.isArray(serverlist?.servers) ? serverlist.servers : []);
                    }, [serverlist]); 

  console.log("serverTypesLst", serverTypesLst.servers);
  console.log("dataCentersList", dataCentersList.servers);
  console.log("remoteControls", remoteControls.servers);
  console.log("remotePanels", remotePanels.servers);


  // const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filterQuery, setFilterQuery] = useState({
    limit: "10",
    page: "1",
  });
  const [formData, setFormData] = useState({
    Name: "", // Required
    location: "", // Should store a MongoDB ObjectId
    server: "", // Should store a MongoDB ObjectId
    serverType: "", // Should store a MongoDB ObjectId
    remoteType: "", // Should store a MongoDB ObjectId
    pannelType: [], // Array of MongoDB ObjectIds
    serverConf: {
      hostName: "", // Required
      port: "", // Not required
      userName: "", // Required
      password: "", // Required
    },
    serverDesc: {
      ram: "", // Required
      hddtype: "", // Not required
      storage: "", // Required
      backup: "", // Required
    },
    pannelConf: {
      hostName: "", // Required
      userName: "", // Required
      password: "", // Required
    },
    status: "1", // Required, default "1"
  });
  


  useEffect(() => {
    if (formData.serverType) {
      setFilteredRemoteTypes(
        remoteTypes.filter(item => item.serverType && item.serverType._id === formData.serverType)
      );
      setFilteredPanelTypes(
        panelTypes.filter(item => item.serverType && item.serverType._id === formData.serverType)
      );

      // Reset remote/panel type when server changes
      setFormData((prev) => ({
        ...prev,
        remoteType: "",
        pannelType: "",
      }));
    }
  }, [formData.serverType, remoteTypes, panelTypes]);


  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  const handleSaveRdp = (e) => {
    e.preventDefault();
    

  // Dispatch with the corrected format
  // dispatch(saveNewRdps(formattedData));
    dispatch(saveNewRdps(formData));
    setFormData({
      Name: "", // Required
    location: "", // Should store a MongoDB ObjectId
    server: "", // Should store a MongoDB ObjectId
    serverType: "", // Should store a MongoDB ObjectId
    remoteType: "", // Should store a MongoDB ObjectId
    pannelType: [], // Array of MongoDB ObjectIds
    serverConf: {
      hostName: "", // Required
      port: "", // Not required
      userName: "", // Required
      password: "", // Required
    },
    serverDesc: {
      ram: "", // Required
      hddtype: "", // Not required
      storage: "", // Required
      backup: "", // Required
    },
    pannelConf: {
      hostName: "", // Required
      userName: "", // Required
      password: "", // Required
    },
    status: "1", // Required, default "1"
    });
    toast.success("New Rdp saved Successfully!", {
      position: "top-right", // Use string instead of POSITION.TOP_RIGHT
      autoClose: 600,
      onClose: () => {
        getRdpsList();
      },
    });
    setIsModalOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleNestedChange = (e, section) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [name]: value,
      },
    }));
  };
  const getRdpsList = () => {
    dispatch(getAllRdps(filterQuery));
  };

  return (
    <div className="relative bg-[#cbd5e0]">
      <div className=" bg-top p-2  fixed  w-full lg:max-w-[calc(100%-16rem)] z-10 bg-[#cbd5e0]">
        <div className="w-full flex items-center justify-between p-1  gap-4">
          <div className="text-text text-lg font-medium">Add New User</div>
          <button
            type="button"
            className="flex items-center text-#02256d hover:text-blue-800 hover:underline rounded-lg text-base"
            onClick={() => navigate(-1)} // Go back to the previous page
          >
            <IoArrowBack className="mr-2 w-5 h-5" /> {/* Icon with margin */}
            Go Back
          </button>
        </div>
      </div>
      <div className="flex bg-card mx-2 pt-12 justify-center items-center lg:h-[95vh] bg-[#cbd5e0]">
      <div className="lg:w-[85%] m-2 bg-slate-200 rounded-lg shadow dark:bg-gray-700">
        {/* Modal Header */}
        <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
            Add New Rdp
          </h3>
         
        </div>

        {/* Modal Body */}
     

        {/* By Rajnish,  */}
        <form
      className="p-4 md:p-5 max-h-[80vh] overflow-y-auto"
      onSubmit={handleSaveRdp}
    >
      <div className="grid gap-4 mb-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
        {Object.keys(formData).map((key) => {
          if (typeof formData[key] === "object") {
            return Object.keys(formData[key]).map((subKey) => (
              <div key={`${key}-${subKey}`} className="col-span-2 md:col-span-1">
                <label
                  htmlFor={`${key}-${subKey}`}
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  {`${key} ${subKey}`}
                </label>
                <input
                  type="text"
                  id={`${key}-${subKey}`}
                  name={subKey}
                  value={formData[key][subKey]}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      [key]: { ...prev[key], [subKey]: e.target.value },
                    }))
                  }
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                  required
                />
              </div>
            ));
          } else if (key === "serverType" || key === "remoteType" || key === "pannelType" || key ==="location" || key ==="server") {
            const options =
              key === "serverType"
                ? serverTypes
                : key === "remoteType"
                ? filteredRemoteTypes
                :key ==="location"
                ? dataCenters
                :key ==="server"
                ? servers
                : filteredPanelTypes;

            return (
              <div key={key} className="col-span-2 md:col-span-1">
                <label
                  htmlFor={key}
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  {key}
                </label>
                <select
                  id={key}
                  name={key}
                  value={formData[key]}
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                  required
                >
                  <option value="">Select an option</option>
                  {options.filter((items)=>items.status!=='0').map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
            );
          } else {
            return (
              <div key={key} className="col-span-2 md:col-span-1">
                <label
                  htmlFor={key}
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  {key}
                </label>
                <input
                  type="text"
                  id={key}
                  name={key}
                  value={formData[key]}
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                  required
                />
              </div>
            );
          }
        })}
      </div>
      <button
        type="submit"
        className="w-full justify-center text-white inline-flex items-center bg-[#02256d] hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700"
      >
        Save
      </button>
    </form>
      </div>
      </div>
    </div>
  );
};

export default ServerListAdd;
